export const Items = [
    {
        title : "Home",
        url : "/",
        cname : "nav-links",
        icon : "fa-solid fa-house-user"
    },
    {
        title : "Content",
        url : "/content",
        cname : "nav-links",
        icon : "fa-solid fa-house-user"
    },
    {
        title : "About",
        url : "/about",
        cname : "nav-links",
        icon : "fa-solid fa-circle-info"
    },
    {
        title : "Sign-up",
        url : "/signup",
        cname : "nav-links-mobile",
    }
]